import { Entry } from "contentful";
import { ImgHTMLAttributes } from "react";

import MediaAsset from "~/components/common/media-asset";
import Editorials from "~/types/editorials";
import { isActiveEntry } from "~/utils/editorial-utils";

type Props = {
  entry?: Entry<Editorials.SingleAsset>;
  entryFallback?: Entry<Editorials.Asset>;
  fill?: boolean;
  width?: number;
  height?: number;
  noLazy?: boolean;
} & Omit<ImgHTMLAttributes<HTMLImageElement>, "placeholder">;

export default function SingleAsset({ entry, entryFallback, fill, width, height, ...rest }: Props) {
  if (entry && isActiveEntry(entry)) {
    const { asset, poster, autoPlay, controls, loop, muted, playsInline } = entry.fields;
    const videoConfig = { autoPlay, controls, loop, muted, playsInline };

    return (
      <MediaAsset
        entry={asset}
        poster={poster?.fields?.file?.url}
        videoConfig={videoConfig}
        fill={fill}
        width={width}
        height={height}
        {...rest}
      />
    );
  } else if (entryFallback) {
    return <MediaAsset entry={entryFallback} fill={fill} width={width} height={height} {...rest} />;
  }

  return null;
}
